// removed by extract-text-webpack-plugin
module.exports = {"tag":"_1Syf2pKj1KScQslJTaazmb","loading":"xU-l8potOvPYAY2rTtJHt","removed":"_3eSpxl7470SHCWdptRL_a5"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Tag/style.scss
// module id = 47
// module chunks = 0